import {useEffect, useState} from "react"
import viewLoadingTips from "../Modal/SolutionSuggestions/ViewLoadingTips"
import {tip} from "../settings"

export const useTipCounter = () => {
    const [tipIndex, setTipIndex] = useState(0)

    useEffect(() => {
       let intervalId = null
       const intervalDuration = tip.viewDuration
       intervalId = setInterval(() => {
           setTipIndex((tipIndexPrev) => tipIndexPrev + 1 > viewLoadingTips.length - 1 ? 0 : tipIndexPrev + 1)
       }, intervalDuration)
       return () => {
           clearInterval(intervalId)
       }
   }, [])

   const getName = () => {
       return viewLoadingTips[tipIndex].name
   }

   const getDescription = () => {
       return viewLoadingTips[tipIndex].description
   }

   const getImage = () => {
       return viewLoadingTips[tipIndex].imagePath
   }

   const previousItem = () => {
       setTipIndex((tipIndexPrev) => tipIndexPrev - 1 < 0 ? viewLoadingTips.length - 1 : tipIndexPrev - 1) 
   }

   const nextItem = () => {
       setTipIndex((tipIndexPrev) => tipIndexPrev + 1 > viewLoadingTips.length - 1 ? 0 : tipIndexPrev + 1)
   }

   const getCurrentIndex = () => {
       return tipIndex
   }

   return {getName, getDescription, getImage, previousItem, nextItem, getCurrentIndex}
}